import {Competition} from '../resources/Competition';
import {DomainEvent} from './DomainEvent';

export abstract class CompetitionEvent extends DomainEvent<Competition> {}
